<div class="perf-overlay">
  <div class="perf-header" (click)="toggleCollapsed()" role="button" tabindex="0">
    <span class="perf-title">PERFORMANCE</span>
    <span class="perf-fps">{{ fpsText() }} fps</span>
    <span class="perf-toggle">{{ collapsed() ? '▸' : '▾' }}</span>
  </div>
  @if (!collapsed()) {
    <div class="perf-totals">
      <span>wall</span><span class="perf-total-val">{{ wallMsText() }} ms</span> <span>max</span
      ><span class="perf-total-val">{{ wallMaxMsText() }} ms</span> <span>cpu</span
      ><span class="perf-total-val">{{ cpuTotalText() }} ms</span> <span>gpu</span
      ><span class="perf-total-val">{{ gpuTotalText() }} ms</span> <span>gap</span
      ><span class="perf-total-val">{{ gapMsText() }} ms</span>
    </div>

    <table class="perf-table">
      <thead>
        <tr>
          <th class="col-name">Pass</th>
          <th class="col-num">CPU</th>
          <th class="col-num">GPU</th>
        </tr>
      </thead>
      <tbody>
        @for (row of passes(); track row.name) {
          <tr [class.inactive]="!row.active">
            <td class="col-name">{{ row.name }}</td>
            <td class="col-num">{{ row.active ? row.cpu.toFixed(2) : '—' }}</td>
            <td class="col-num">
              {{ !row.active || row.cpuOnly ? '—' : row.gpu.toFixed(2) }}
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (counts(); as c) {
      <div class="perf-counts">
        <div class="count-row">
          <span>Lights</span><span>{{ c.lights }}</span>
        </div>
        <div class="count-row">
          <span>Objects</span><span>{{ c.objects }} ({{ c.draws }} draws)</span>
        </div>
        <div class="count-row">
          <span>Instanced</span><span>{{ c.instances }} in {{ c.instanced }} groups</span>
        </div>
        <div class="count-row">
          <span>Shader switches</span><span>{{ c.shaderSwitches }}</span>
        </div>
        <div class="count-row">
          <span>Faces</span><span>{{ c.faces }}</span>
        </div>
        <div class="count-row">
          <span>CSM rebuilds</span><span>{{ c.csmRebuilds }}</span>
        </div>
        <div class="count-row">
          <span>Long tasks</span><span>{{ c.longTasks }}</span>
        </div>
      </div>
    }
  }
</div>
